import { m, useReducedMotion } from "framer-motion";
import type { ReactNode } from "react";
import { staggerContainer, staggerItem } from "./tokens";

type Tag = "div" | "section" | "ul" | "article";

/** Container that staggers its <StaggerItem> children into view on scroll. */
export function Stagger({
  children,
  as = "div",
  className,
  id,
  stagger,
}: {
  children: ReactNode;
  as?: Tag;
  className?: string;
  id?: string;
  stagger?: number;
}) {
  const reduce = useReducedMotion();
  const Comp = m[as] as typeof m.div;
  if (reduce) {
    return (
      <Comp className={className} id={id}>
        {children}
      </Comp>
    );
  }
  return (
    <Comp
      className={className}
      id={id}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "0px 0px -10% 0px" }}
      variants={staggerContainer(stagger)}
    >
      {children}
    </Comp>
  );
}

type ItemTag = "div" | "article" | "li" | "figure";

/** A child of <Stagger>; inherits the staggered fade-up timing. */
export function StaggerItem({
  children,
  as = "div",
  className,
}: {
  children: ReactNode;
  as?: ItemTag;
  className?: string;
}) {
  const reduce = useReducedMotion();
  const Comp = m[as] as typeof m.div;
  if (reduce) {
    return <Comp className={className}>{children}</Comp>;
  }
  return (
    <Comp className={className} variants={staggerItem}>
      {children}
    </Comp>
  );
}
